import {
  getModule,
  Module,
  MutationAction,
  VuexModule
} from 'vuex-module-decorators';
import { Paging, User } from '@/store/models';
import store from '@/store';
import coachService from '@/services/common/coach.service';

@Module({ namespaced: true, name: 'coach', store, dynamic: true })
class CoachModule extends VuexModule {
  public coaches: User[] | [] = [];
  public paging: Paging | null = null;

  @MutationAction({ mutate: ['coaches', 'paging'], rawError: true })
  async loadCoaches(params?: {
    search_key?: string;
    order_by?: string;
    one_step_only?: number;
    offset?: number;
    limit?: number;
  }) {
    const response = await coachService.loadCoaches(params);
    return { coaches: response.users, paging: response.paging };
  }

  @MutationAction({ mutate: ['coaches', 'paging'], rawError: true })
  async updateCoaches(coaches: User[] | [], paging: Paging | null) {
    return { coaches: coaches, paging: paging };
  }
}

const coachModule = getModule(CoachModule);
export default coachModule;
